import { useCurrentWell } from "@hooks/useCurrentWell";

/**
 * Resolve the pad/site for the current well (§12). A pad = a Site in the Oxbo-M
 * well register (wells belong to a site); `WellView` does not yet surface a
 * `site_id`, so until Oxbo-M exposes the grouping we resolve to the demo pad and
 * let the served rollup be the source of truth. When the register carries
 * `well.site_id`, this collapses to `well.site_id`.
 */
/** The seeded demo pad — the resolution target until `well.site_id` exists. */
const DEMO_SITE_ID = "site-nesson";

export function usePadSite(): { siteId: string; wellReady: boolean } {
  const { isLoading } = useCurrentWell();
  // Placeholder resolution: everything demos against the seeded pad. The real
  // mapping is `well.site_id` once the register carries it.
  return { siteId: DEMO_SITE_ID, wellReady: !isLoading };
}
